module.exports = __webpack_public_path__ + "static/customerbg1_mobile-e70349dc3408b47b31a799398c1047d6.png";